/**
 * use this to have ctrl-S speak what's in a <textarea>
 *  <textarea onKeyDown={e => speakOnCtrlS(e, speakContents)} />
 */
export function speakOnCtrlS(event: React.KeyboardEvent<HTMLTextAreaElement>, f: () => void) {
  if (event.ctrlKey && event.key === 's') {
    event.preventDefault();
    f();
  }
}
